import CriteriaVM from './criteria-vm';
import FieldDefs from './field-defs';
import Fields from '../../../student/coursework/form_submission/fields';
export default function (data, parent) {
  var self = this;
  var r = Kadenze.Util.objFromString;
  var nameKey = {
    FillInTheBlankField: Kadenze.I18n.t('form_builder.fill_in_the_blank_question'),
    WrittenResponseField: Kadenze.I18n.t('form_builder.written_response_question'),
    MultipleChoiceField: Kadenze.I18n.t('form_builder.multiple_choice_question'),
    TrueFalseField: Kadenze.I18n.t('form_builder.true_false_question'),
    RatingField: Kadenze.I18n.t('form_builder.rating_question'),
    AnswerBuilderField: Kadenze.I18n.t('form_builder.answer_builder_question'),
    TimelineField: Kadenze.I18n.t('form_builder.timeline_question'),
    InteractiveTimelineField: Kadenze.I18n.t('form_builder.interactive_timeline_question'),
    MatrixField: Kadenze.I18n.t('form_builder.matrix_question'),
    ImageMatchingField: Kadenze.I18n.t('form_builder.image_matching_question'),
    SectionBreakField: Kadenze.I18n.t('form_builder.section_break')
  };
  var variant_counter = 0;

  self.id = ko.observable(r(data, 'id', '')).withPausing(); //This will keep the question panel open if it has no value (thus new)
  self.dom_id = ko.observable('q-' + (self.id() || 'new-' + _.random(100)));
  self.in_holder = ko.observable(r(data, 'in_holder', false)); //This will persist the question in the holder after auto-save if true
  self.field_definition = ko.observableArray();
  self.extra_credit = ko.observable(r(data, 'extra_credit', false));
  self.editable = ko.observable(r(data, 'editable', true));
  self.editing = ko.observable(r(data, 'editing', false)); //This will keep the question panel open if true
  self.previewing = ko.observable(r(data, 'previewing', true));
  self._destroy = ko.observable(r(data, '_destroy', false));
  self._type = ko.observable(r(data, '_type'));

  self.coursework_type = ko.computed(function() {
    return parent.coursework() ? parent.coursework().type().toLowerCase() : '';
  });

  self.submissionsBegun = ko.computed(function() {
    return parent.coursework() ? parent.coursework().submissions_begun() : false;
  });

  self.isSurvey = ko.computed(function() {
    return self.coursework_type() == 'survey';
  });

  self.isWorksheet = ko.computed(function() {
    return self.coursework_type() == 'worksheet';
  });

  self.isTemplate = ko.computed(function() {
    return parent.coursework() ? parent.coursework().template() : false;
  });

  self.isUsingTemplate = ko.computed(function() {
    return parent.coursework() ? parent.coursework().template_id() : false;
  });

  self.isSectionBreak = ko.computed(function() {
    return self._type() == 'SectionBreakField';
  });

  self.isTemplateEditable = ko.computed({
    read: function() {
      return self.editable();
    },
    write: function(value) {
      if (value) {
        Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('form_builder.template_editability_confirmation'), function() {
          self.editable(value);
        }, function() {
          self.isTemplateEditable.notifySubscribers();
        });
      } else {
        self.editable(value);
      }
    }
  });

  self.isEditable = ko.computed(function() {
    return self.isTemplate() || self.editable();
  });

  self.bindSubmissionVM = function () {
    var type = data._type;
    var $container = $('#' + self.dom_id() + '-preview').find('.js-preview');

    if (_.isEmpty($container.html())) {
      var vm = Fields[data._type] ? new Fields[data._type](data, parent.coursework()) : new Fields.BaseField(data, parent.coursework());
      vm.$index = function() { return 1; };
      vm.isPreviewing(true);

      var template = parent.templates[type + 'Preview'];
      $container.html(template);

      ko.applyBindingsWithValidation(vm, $container[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
    }
  };

  self.addFieldDefinition = function(fd, active) {
    var dom_id = self.dom_id() + '-t-' + variant_counter++;
    var opts = {
      isSurvey: self.isSurvey(),
      isActive: active
    };
    var field_def = new FieldDefs[self._type()](dom_id, fd, opts);
    self.field_definition.push(field_def);
  };

  if(data.field_definition) {
    $.each(data.field_definition, function(index, field_definition) {
      self.addFieldDefinition(field_definition, index === 0);
    });
  }

  self.index = ko.computed(function() {
    return parent.coursework() ? (parent.coursework().coursework_fields().indexOf(self) + 1) : 1;
  });

  self.name = ko.computed(function() {
    var name = '';
    if (self.isSectionBreak()) {
      name = nameKey[self._type()] + ' #' + self.index() + ': Section Break';
    } else {
      name = nameKey[self._type()] + ' #' + self.index() + ': ' + (self.field_definition()[0] ? self.field_definition()[0].question() : '');
    }
    return name.trimToLength(250).toString();
  });

  self.preview_title = ko.computed(function() {
    return ((self.field_definition()[0] && !self.isSectionBreak() && self.field_definition()[0].question()) ? self.field_definition()[0].question() : nameKey[self._type()]).trimToLength(255);
  });

  self.coursework_id = ko.computed(function() {
    return parent.coursework() ? parent.coursework().id() : '';
  });

  self.coursework_points = ko.computed(function() {
    var total_points = 0;
    if (parent.coursework()) {
      ko.utils.arrayForEach(parent.coursework().coursework_fields(), function(field) {
        if(!field.extra_credit() && field.grading_criteria)
          total_points += field.grading_criteria.points();
      });
    }
    return total_points;
  });

  self.has_attachments = ko.computed(function() {
    var has_attachments = false;
    if (self.field_definition) {
      has_attachments = ko.utils.arrayFirst(self.field_definition(), function(field) {
        return (typeof(field.attachment_ids) == 'function') && (field.attachment_ids().length > 0);
      });
    }
    return has_attachments;
  });

  if (!self.isSectionBreak()) {
    self.grading_criteria = new CriteriaVM(data.grading_criteria, self);
  }

  self.initQuestionUI = function(element, item) {
    var $question = $(element);
    var $extra_credit = $question.find('#' + item.dom_id() + '-extra_credit');

    if (_.isEmpty(self.id()) && self.in_holder()) {
      self.expandRow();
      self.editQuestion();
    }

    if(item.extra_credit()) {
      $extra_credit.parent().css('background-position', '0px -32px');
    }
  };

  self.initTabUI = function(element, item) {
    var $tab = $(element);
    var $dropzoneArea = $('#dz-' + $tab.attr('id'));

    if (!_.include(['ImageMatchingField', 'InteractiveTimelineField'], item._type())) {
      self.addDropZoneToTab($dropzoneArea, item);
    }

    if (item._type() == 'MatrixField' && (!self.isUsingTemplate() || self.isEditable())) {
      self.initMatrixSortables(item);
    }

    if (item._type() == 'InteractiveTimelineField') {
      item.initTimeline();
    }
  };

  self.initMatrixSortables = function(fd) {
    var sortable_types = ['rows','columns'];
    _.each(sortable_types, function(type) {
      var $container = $('#' + fd.dom_id() + '-matrix-' + type);
      if ($container.children().length === fd[type]().length) {
        $container.sortable({
          start: function(e, ui) {
            // creates a temporary attribute on the element with the old index
            ui.item.data('startindex', ui.item.index());
          },
          stop: function(e, ui) {
            var startIndex = parseInt(ui.item.data('startindex'), 10);
            var newIndex = ui.item.index();

            var item = fd[type]()[startIndex];

            //remove item from the old position
            fd[type].remove(function(itm) {
              return itm() === item();
            });

            //ko rebinds the array so remove duplicate item from the DOM
            ui.item.remove();

            //insert item back into the list at the new position
            fd[type].splice(newIndex, 0, item);
          }
        });
      }
    });
  };

  self.initOptionsUI = function(element, item) {
    var $option = $(element);
    var $label = $option.find('label');

    if(JSON.parse(item.selected())) {
      $label.addClass('selected');
    }
  };

  self.selectOption = function (option, parent) {
    //TODO: Move this to FieldDefs.Base
    //If this is not a multi_response type, deselect other options and select this one
    if(!parent.multi_response || !parent.multi_response()) {
      _.each(parent.options(), function(option) {
        option.selected(false);
      });
      option.selected(true);
    }
    var selected = _.any(parent.options(), function(option) { return option.selected(); });
    parent.selected_option(selected ? selected : null);
    return true;
  };

  self.validate = function() {
    var propsToValidate = [];
    _.each(Object.getOwnPropertyNames(self), function(key) {
      if (ko.isObservable(self[key])) {
        propsToValidate.push(self[key]);
      }
    });
    var errors = ko.validation.group(propsToValidate, {deep: true});
    errors.showAllMessages(true);
    return errors();
  };

  self.isValid = function () {
    return self.validate().length == 0 && (!self.grading_criteria || self.grading_criteria.isValid());
  };

  self.hideAllTooltips = function($row) {
    _.each($row.find('.js-tooltip'), function(el) {
      var instance = $(el).data('tooltip');
      if (instance) {
        instance.hide();
      }
    });
  };

  self.toggleRow = function() {
    var $row = $('#' + self.dom_id());
    var $editRow = $('.display-table__edit_row', $row).first();
    $row.toggleClass('collapsed');
    $row.toggleClass('expanded');
    $editRow.collapse('toggle');
    if ($row.hasClass('collapsed')) {
      self.hideAllTooltips($row);
    }
    self.previewing(false);
    Kadenze.Layout.update();
  };

  self.expandRow = function() {
    var $row = $('#' + self.dom_id());
    var $editRow = $('.display-table__edit_row', $row).first();
    $row.removeClass('collapsed');
    $row.addClass('expanded');
    $editRow.collapse('show');
  };

  self.previewQuestion = function(item, event) {
    var $question = $('#' + self.dom_id());

    // If user is previewing from the edit view,
    // save the current state and then render the preview
    if ($question.hasClass('expanded') && self.isValid()) {
      var response = parent.save($question, false, true);
      response.success(function() {
        self.expandRow();
      });
      response.error(function (xhr, textStatus, errorThrown) {
        Kadenze.UIUtil.showNotice($question, {message: errorThrown}, 1000);
      });
    } else {
      self.expandRow();
    }

    event.stopPropagation();
  };

  self.editQuestion = function(item, event) {
    self.previewing(false);
    self.editing(true);
    if (!_.isEmpty(event))
      event.stopPropagation();
  };

  self.saveQuestion = function(item, event) {
    var $question = $('#' + self.dom_id());

    var questionElement = $question.find('.ql-editor');
    var isQuestionEmpty = questionElement.text().replace(/\s+/, '') === '';

    if (self.isValid() && self.isEditable() && !isQuestionEmpty) {
      var response = parent.save($question);

      response.success(function() {
        self.editing(false); //Close the panel
        self.in_holder(false); //Remove from the holder
      });

      response.error(xhr => {
        let messages

        if (xhr.responseJSON) {
          messages = xhr.responseJSON.errors
        } else {
          messages = [xhr.statusText]
        }

        messages.forEach(message => {
          Kadenze.UIUtil.showNotice($question, { message }, 1000);
        })
      });
    }
    else {
      if(isQuestionEmpty) {
        $('.quill-required-error').removeClass('hide');
        questionElement.addClass('ql-missing-field-error');
      }
    }
  };

  self.cancelQuestion = function(item, event) {
    if(!item.id()) {
      parent.coursework().coursework_fields.remove(function(question) {
        return question.dom_id() === item.dom_id();
      });
    } else {
      self.editing(false); //Close the panel
      self.in_holder(false); //Remove from the holder
      self.toggleRow();
    }
  };

  self.deleteQuestion = function(item, event) {
    var deleteQuestion = function() {
      if(item.id()) {
        //TODO: Find a way to keep the element in the DOM until XHR success
        item._destroy(true);

        var response = parent.save(parent.$el.find('.col-md-8'));
        response.error(function(xhr, textStatus, errorThrown) {
          item._destroy(false);
          Kadenze.UIUtil.showNotice(parent.$el, {message: errorThrown}, 1000);
        });
      } else {
        parent.coursework().coursework_fields.remove(function(question) {
          return question.dom_id() === item.dom_id();
        });
      }
    };
    if (self.isEditable()) {
      Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('form_builder.delete_question_confirmation'), deleteQuestion);
    }
    event.stopPropagation();
  };

  self.addHostedLectureMedia = function(item, event) {
    if (!self.isEditable()) {
      return;
    }
    var $tabPane = $(event.target).parents('.tab-pane');
    var $associatedInputField = $(event.target).parentsUntil('.tab-pane').find('input');
    var vurl = $associatedInputField.val().trim();
    var $notice = $associatedInputField.parent().parent();

    vurl = Kadenze.IframeMediaPlayer.extractUrl(vurl);

    if (!vurl) {
      Kadenze.UIUtil.showNotice($notice, {message: Kadenze.I18n.t('validation.embedded_video_url.invalid')}, 3000);
      return;
    }

    //save attachment
    var post_url = Kadenze.Routes.attachments_path();

    $.ajax({
      method: 'POST',
      url: post_url,
      data: {attachment: { url: vurl } },
      dataType: 'json',
      beforeSend: function() {
        parent.saving(true);
      },
      complete: function() {
        parent.saving(false);
      },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function(response) {
      //clear input
      $associatedInputField.val('');

      if(response.files[0]) {
        //update attachment ids
        item.attachment_ids.push(response.files[0].id);
        item.attachment_ids(Kadenze.Util.cleanupArray(item.attachment_ids()));

        //create media table row
        var id = response.files[0].id.toString();
        var title = response.files[0].url.toString();
        var fsize = response.files[0].size.toString();
        fsize = (fsize < 1000000 ) ? (Math.round(fsize / 100) / 10) + ' KB' : (Math.round(fsize / 100000) / 10) + ' MB';

        var $vid_row = $(JST['templates/dropzone-session-preview']({title: title, file_size: fsize}));

        //insert an id
        $vid_row.attr('id', 'attachment_' + id);
        $vid_row.attr('value', id);

        //add to dom
        var $insertionPoint = $('.dz-media-preview', $tabPane);
        $insertionPoint.append($vid_row);

        //hook in missing action handlers for this as-yet unsaved question
        $vid_row.on('click', '.action-btn--delete', function(evt) {
          item.attachment_ids.remove(function(attachment_id)
          {
            return attachment_id.toString() === id;
          });

          //remove from dom
          var $tgt = $(this);
          var $parent = $(this).closest('.tr.dz-table-preview');
          $parent.remove();
        });

        //update ordering
        $tabPane.find('.dz-table-preview').each(function() {
          $(this).find('.in-table__order-num').text($(this).index() + 1);
        });
      }
      console.log('vimeo/youtube attachment added successfully');

    }).error(function(xhr, textStatus, errorThrown) {
      Kadenze.UIUtil.showNotice($notice, xhr.responseJSON, 3000);
    });
  };

  self.addTab = function() {
    if (self.field_definition().length >= 3) {
      Kadenze.UIUtil.showNotice(parent.$el, {status: 'error', message: 'Sorry, adding more than 3 variants is not permitted.'}, 3000);
      return;
    }
    self.hideAllTabs();
    self.addFieldDefinition({_type: self._type()}, true);
  };

  self.removeTab = function() {
    self.field_definition.remove(function(field) {
      return field.active() === true;
    });
    self.hideAllTabs();
    self.showLastTab();
  };

  self.hideAllTabs = function() {
    ko.utils.arrayForEach(self.field_definition(), function(field) {
      field.active(false);
    });
  };

  self.showTab = function(item, event) {
    self.hideAllTabs();
    item.active(true);
  };

  self.showLastTab = function() {
    self.field_definition()[self.field_definition().length - 1].active(true);
  };

  self.addDropZoneToTab = function($dropArea, item) {
    var $question = $('#' + item.dom_id());
    var fileTypes = '.jpg, .png, .m4a, .mov';
    var message = JST['templates/dropzone-generic']( {
      title: Kadenze.I18n.t('drop_file_editor.question_media_title'),
      hideUpperTitle: true,
      fileTypes: fileTypes,
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    }
    );

    var opts = {
      autoProcessQueue: self.isEditable(),
      paramName: 'attachment[file]',
      previewsContainer: '#' + item.dom_id() + ' .dz-media-preview'
    };

    var callbacks = {
      sending: function(file, xhr, formData) {
        parent.saving(true);
        Kadenze.UIUtil.showLoadingIndicator($question);
      },
      success: function(file, response) {
        if(response.files[0]) {
          file.id = response.files[0].id;
          item.attachment_ids.push(file.id);
          item.attachment_ids(Kadenze.Util.cleanupArray(item.attachment_ids()));
          $(file.previewTemplate).attr('id', 'attachment_' + file.id);
          $(file.previewTemplate).attr('value', file.id);
        }
      },
      error: function(file, errorMessage) {
        Kadenze.UIUtil.showNotice($('#' + item.dom_id()), {message: errorMessage}, 1000);
      },
      complete: function(file) {
        parent.saving(false);
        Kadenze.UIUtil.hideLoadingIndicator($question);
      },
      removedfile: function(file) {
        if (self.isEditable()) {
          var file_id = file.id;
          item.attachment_ids.remove(function(attachment_id) {
            return attachment_id === file_id;
          });
        }
      },
      sortableUpdate: function(e, ui) {
        var orderd_ids = $(opts.previewsContainer).sortable('toArray', {attribute: 'value'});
        orderd_ids = orderd_ids.map(function(x){return parseInt(x);});
        item.attachment_ids(orderd_ids);
      }
    };

    var mediaDZ = Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);

    $.each(item.attachments(), function(index, attachment) {
      if (attachment) {
        var mockFile = { id: attachment.id, name: attachment.name, path: attachment.file.url, thumb: attachment.file.thumb.url, size: attachment.size, status: Dropzone.SUCCESS, type: attachment.meta.type };
        mediaDZ.addMockFile(mockFile);
        mediaDZ.options.maxFiles--;
      }
    });

    if (!self.isEditable()) {
      mediaDZ.hiddenFileInput.disabled = true;
      mediaDZ.options.clickable = false;
      $(mediaDZ.element).find('#js-dz-btn').addClass('btn--disabled');
    }
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorFormFieldViewModel');

    var fd = Kadenze.Util.objFromString(data, 'field_definition', []);
    if(fd.length === 0) {
      that.addTab();
    }
  }(this);
}

